import { NgModule, Optional, SkipSelf } from "@angular/core";
import { I18nService } from "./i18n.service";
import { MissingTranslationHandler, TranslateParser } from "ng2-translate";
export class I18nModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('I18nModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * Provide the I18nService both as itself and also as a TranslateParser and MissingTranslationHandler.
     * @return ModuleWithProviders
     */
    static forRoot() {
        return {
            ngModule: I18nModule,
            providers: [
                I18nService,
                { provide: TranslateParser, useClass: I18nService },
                { provide: MissingTranslationHandler, useClass: I18nService }
            ]
        };
    }
}
I18nModule.decorators = [
    { type: NgModule, args: [{},] },
];
/** @nocollapse */
I18nModule.ctorParameters = () => [
    { type: I18nModule, decorators: [{ type: Optional }, { type: SkipSelf },] },
];
//# sourceMappingURL=i18n.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/i18n/i18n.module.js
// module id = 413
// module chunks = 1